import { render, staticRenderFns } from "./Stockistrecord.vue?vue&type=template&id=5ae531ed&scoped=true"
import script from "./Stockistrecord.vue?vue&type=script&lang=js"
export * from "./Stockistrecord.vue?vue&type=script&lang=js"
import style0 from "./Stockistrecord.vue?vue&type=style&index=0&id=5ae531ed&prod&scoped=true&lang=css"
import style1 from "./Stockistrecord.vue?vue&type=style&index=1&id=5ae531ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae531ed",
  null
  
)

export default component.exports